import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { ConfirmContainer } from "./style";
import Button from "components/button";
import UserData from "./components/userData";
import { FiEdit3 } from "react-icons/fi";
import Modal from "components/modal";
import GetwaySelect from "components/gatwaySelect";
import NumberFormat from "components/numberFormat";
const Confirm = ({
  item,
  selectedDealer,
  prev,
  submit,
  goTo,
  loading,
  selectedGeteway,
  setGeteway,
}) => {
  const [modalStatus, setModalStatus] = React.useState(false);
  const [policyStatus, setPolicyStatus] = React.useState(false);
  return (
    <ConfirmContainer>
      <div className="title">
        <h5>تایید اطلاعات</h5>
      </div>
      <section className="detail">
        {item.costs.items.map((cost, index) => (
          <div className="item" key={index}>
            <span className="title">{cost.title}</span>
            <span className="value">
              <NumberFormat value={cost.value} />
            </span>
          </div>
        ))}
        <div className="item bold">
          <span className="title">جمع کل</span>
          <span className="value">
            <NumberFormat value={item.costs.total} />
          </span>
        </div>
      </section>
      <div className="dealer-box">
        <h5>{selectedDealer.title}</h5>
        <FiEdit3 className="edit-icon" onClick={() => goTo("dealer")} />
        <Row>
          <Col sm={12} md={5}>
            <div className="text">
              کد نمایندگی: {selectedDealer.description}
            </div>
            <div className="phone">تلفن: {selectedDealer.phone}</div>
          </Col>
          <Col sm={12} md={7}>
            <div className="province-city">
              استان: {selectedDealer.province} - شهر: {selectedDealer.city}
            </div>
            <div className="address">آدرس: {selectedDealer.address}</div>
          </Col>
        </Row>
      </div>
      <UserData goTo={() => goTo("form")} />
      <div className="recaptcha">
        <div className="policy">
          <input
            type="checkbox"
            checked={policyStatus}
            onChange={() => setPolicyStatus(!policyStatus)}
          />
          <label>
            متن
            <span
              onClick={(e) => {
                e.stopPropagation();
                setModalStatus(true);
              }}
            >
              {" "}
              توافق نامه{" "}
            </span>
            را مطالعه کرده و مورد تایید می باشد
          </label>
        </div>
      </div>
      <GetwaySelect
        gateways={item.gateways}
        selected={selectedGeteway}
        setGeteway={setGeteway}
      />
      <div className="buttons">
        <Button title="مرحله قبل" onClick={prev} />
        <Button
          disabled={!policyStatus || !selectedGeteway}
          loading={loading}
          title="ثبت نهایی"
          onClick={submit}
        />
      </div>
      <Modal
        status={modalStatus}
        size="big"
        close={() => setModalStatus(false)}
      >
        <div dangerouslySetInnerHTML={{ __html: item?.note }} />
      </Modal>
    </ConfirmContainer>
  );
};
export default Confirm;
